import { mergeClasses, Text } from '@fluentui/react-components';
import parse from 'html-react-parser';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useCommonStyles, useStores } from '../../../common/hooks';
import { getCleanHtmlString } from '../../../common/html-string/get-clean-html-string';
import { Award } from '../../../models';
import { FlexBox } from '../../shared-components/flex-box';
import './AwardDetailView.scss';

interface AwardDetailViewProps {
  selectedAward: Award;
}

const AwardDetailViewImpl: React.FC<AwardDetailViewProps> = (props) => {
  const {
    selectedAward,
  } = props;

  const {
    manageAwardListPageUiStore,
  } = useStores();

  const commonStyles = useCommonStyles();

  return (
    <div
      className='award-detail-view'
    >
      <FlexBox
        direction='column'
        className='award-detail-view__header'
      >
        <Text
          size={500}
          weight='semibold'
          block
        >
          {selectedAward.title}
        </Text>
        {!!manageAwardListPageUiStore.selectedMasterAward && <Text>Master list name: {manageAwardListPageUiStore.selectedMasterAward.title}</Text>}
      </FlexBox>
      <div
        className={mergeClasses(commonStyles.richTextContent, 'award-detail-view__description')}
      >
        {parse(getCleanHtmlString(selectedAward.summary))}
      </div>
    </div>
  );
}

export const AwardDetailView = observer(AwardDetailViewImpl);
